import { executeRequest, Request } from '@jfs/network'
import { getNetworkResponseError } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  if (data.status === 'SUCCESS') {
    return data
  } else {
    throw data
  }
}

const blockUnblockUser = (tokens: any, reqBody: any) => {
  console.log('reqBody', reqBody)
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.blockUnblockUser,
    method: 'POST',
    cache: false,
    body: reqBody,
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data?.data)
    })
    .catch((err) => {
      throw getNetworkResponseError(err.data ?? err)
    })
}

export { blockUnblockUser }
